<template>
  <div class="flex justify-center w-full">
    <ul v-if="total_pages > 1" class="flex pl-0 my-2 list-none">
      <li class="flex items-center justify-center w-10 h-10 mr-1">
        <button
          title="上一頁"
          type="button"
          class="w-full h-full px-3 py-2 rounded-md"
          :class="
            isInFirstPage
              ? 'cursor-not-allowed opacity-10'
              : 'hover:md:bg-secondary hover:md:text-white text-secondary transition-colors duration-200'
          "
          :disabled="isInFirstPage"
          @click="gotoPrevious"
        >
          <span
            class="block text-current transform icon-arrow-right -scale-x-100"
          ></span>
        </button>
      </li>

      <template v-if="showDots('left')">
        <li class="flex items-center justify-center w-10 h-10">
          <button
            title="第一頁"
            type="button"
            class="flex items-center justify-center w-full h-full text-sm font-bold transition-colors duration-200 rounded-md hover:md:bg-secondary hover:md:text-white"
            :class="{
              'cursor-not-allowed bg-secondary text-white': isInFirstPage,
              'bg-zinc-100': !isInFirstPage,
            }"
            :disabled="isInFirstPage"
            @click="gotoPageNumber(1)"
          >
            1
          </button>
        </li>
        <li class="flex items-center justify-center w-7 h-7">
          <button title="更多" type="button" class="" :disabled="true">
            ...
          </button>
        </li>
      </template>

      <li
        class="w-10 h-10 mx-1 leading-none rounded-md"
        v-for="(page, index) in pages"
        :key="`pages_${index}`"
      >
        <button
          :title="`第${page}頁`"
          type="button"
          class="flex items-center justify-center w-full h-full text-sm font-bold transition-colors duration-200 rounded-md hover:md:bg-secondary hover:md:text-white"
          :class="{
            'cursor-not-allowed bg-secondary text-white': page === currentPage,
            'bg-zinc-100': page != currentPage,
          }"
          :disabled="page === currentPage"
          @click="gotoPageNumber(page)"
        >
          {{ page }}
        </button>
      </li>

      <template v-if="showDots('right')">
        <li class="flex items-center justify-center w-7 h-7">
          <button title="更多" type="button" class="" :disabled="true">
            ...
          </button>
        </li>

        <li class="flex items-center justify-center w-10 h-10">
          <button
            title="總頁數"
            type="button"
            class="flex items-center justify-center w-full h-full text-sm font-bold transition-colors duration-200 rounded-md hover:md:bg-secondary hover:md:text-white"
            :class="{
              'cursor-not-allowed bg-secondary text-white': isInLastPage,
              'bg-zinc-100': !isInLastPage,
            }"
            :disabled="isInLastPage"
            @click="gotoPageNumber(total_pages)"
          >
            {{ total_pages }}
          </button>
        </li>
      </template>

      <li class="flex items-center justify-center w-10 h-10 ml-1">
        <button
          title="下一頁"
          type="button"
          class="w-full h-full px-3 py-2 rounded-md"
          :class="
            isInLastPage
              ? 'cursor-not-allowed opacity-10'
              : 'hover:md:bg-secondary hover:md:text-white text-secondary transition-colors duration-200'
          "
          :disabled="isInLastPage"
          @click="gotoNext"
        >
          <span class="text-current icon-arrow-right"></span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PaginationComponent",
  props: {
    currentPage: { type: Number, required: true, default: 1 },
    pagination: { type: Object, required: true, default: () => ({}) },
    maxVisibleButtons: { type: Number, required: false, default: 3 },
  },
  data() {
    return {
      per_page: 5,
      total: 0,
      total_pages: 0,
    };
  },
  methods: {
    showDots(position = "left") {
      const number = position === "left" ? 1 : this.total_pages;
      const nextNumber = position === "left" ? 2 : this.total_pages - 1;

      return !this.pages.includes(number) || !this.pages.includes(nextNumber);
    },

    gotoFirst() {
      this.gotoPageNumber(1);
    },

    gotoLast() {
      this.gotoPageNumber(this.total_pages);
    },

    gotoPrevious() {
      this.gotoPageNumber(this.currentPage - 1);
    },

    gotoNext() {
      this.gotoPageNumber(this.currentPage + 1);
    },

    gotoPageNumber(pageNumber) {
      this.$emit("pagechanged", pageNumber);
    },
  },
  watch: {
    "pagination.total_pages"() {
      this.per_page = this.pagination.per_page || 5;
      this.total = this.pagination.total || 0;
      this.total_pages = this.pagination.total_pages || 0;
    },
  },
  created() {
    this.per_page = this.pagination.per_page || 5;
    this.total = this.pagination.total || 0;
    this.total_pages = this.pagination.total_pages || 0;
  },
  computed: {
    isInFirstPage() {
      return this.currentPage === 1;
    },

    isInLastPage() {
      return this.currentPage === this.total_pages;
    },

    pages() {
      const range = [];

      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push(i);
      }

      return range;
    },

    startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.total_pages) {
        let num = this.total_pages - this.maxVisibleButtons + 1;
        num < 1 ? (num = 1) : "";
        return num;
      }

      return this.currentPage - 1;
    },

    endPage() {
      return Math.min(
        this.startPage + this.maxVisibleButtons - 1,
        this.total_pages
      );
    },
  },
};
</script>
